@if(form()){
<form [formGroup]="form()">
        <div class="grid grid-cols-1 gap-2">

    @for (field of entityModelFields(); track $index) {
        @if(field.fieldType=='text'){
        <spike-field-text 
            [label]="field.label ? field.label: field.fieldName"
            [formControlName]="field.fieldName"
            [placeholder]="field.label ? field.label: field.fieldName">
        </spike-field-text>
        }
        @if(field.fieldType=='number'){
        <spike-field-number 
            [label]="field.label ? field.label: field.fieldName"
            [formControlName]="field.fieldName"
            [placeholder]="field.label ? field.label: field.fieldName">
        </spike-field-number>

        }
        @if(field.fieldType=='date'){
       <spike-field-date 
            [label]="field.label ? field.label: field.fieldName"
            [formControlName]="field.fieldName"
            [placeholder]="field.label ? field.label: field.fieldName">
        </spike-field-date>
        }
       
    }
    </div>

</form>
}